/**
 * Desktop dropdown hover intent helper
 */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 992px)';
  var matchMediaFn = window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;

  function isDesktop() {
    return matchMediaFn ? matchMediaFn.matches : window.innerWidth >= 992;
  }

  function setupHoverIntent(item) {
    var submenu = item.querySelector('.sub-menu');
    if (!submenu) {
      return;
    }

    var hideTimeout = null;

    function clearHideTimeout() {
      if (hideTimeout) {
        window.clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    }

    function showDropdown() {
      if (!isDesktop()) {
        return;
      }
      clearHideTimeout();
      item.classList.add('is-hovering');
    }

    function scheduleHide() {
      if (!isDesktop()) {
        return;
      }
      clearHideTimeout();
      hideTimeout = window.setTimeout(function () {
        item.classList.remove('is-hovering');
      }, 400);
    }

    item.addEventListener('mouseenter', showDropdown);
    item.addEventListener('mouseleave', scheduleHide);

    submenu.addEventListener('mouseenter', showDropdown);
    submenu.addEventListener('mouseleave', scheduleHide);
  }

  function tearDownHoverIntent(item) {
    item.classList.remove('is-hovering');
  }

  function init() {
    var items = document.querySelectorAll('.site-header__menu > .menu-item-has-children');
    if (!items.length) {
      return;
    }

    items.forEach(setupHoverIntent);

    if (matchMediaFn) {
      var onBreakpointChange = function (event) {
        if (!event.matches) {
          items.forEach(tearDownHoverIntent);
        }
      };

      if (typeof matchMediaFn.addEventListener === 'function') {
        matchMediaFn.addEventListener('change', onBreakpointChange);
      } else if (typeof matchMediaFn.addListener === 'function') {
        matchMediaFn.addListener(onBreakpointChange);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
